module.exports = __webpack_public_path__ + "static/media/ross.b4a617fa.jpg";